import React from 'react';

/** Grey box of the generate / regenerate dialogs. */
const PeriodBox = ({ label, children }) => (
  <div className="mt-4 rounded-lg bg-gray-50 px-3.5 py-3 text-sm dark:bg-night-850">
    <p className="text-[11px] font-semibold uppercase tracking-wider text-gray-500 dark:text-gray-400">{label}</p>
    <p className="mt-0.5 tabular-nums text-gray-900 dark:text-white">{children}</p>
  </div>
);

export default PeriodBox;
